import uk from './../lang/uk.json';

export default function __(key, replaceOrInteger) {

    let translation = uk[key] ? uk[key] : key

    if( translation.indexOf('|') != -1 )
    {
        const translations = translation.split('|');
        replaceOrInteger = typeof replaceOrInteger === "undefined" ? 0 : replaceOrInteger;

        // todo: make it work with 21, 31 and other intgers...
        if (replaceOrInteger === 0 || replaceOrInteger > 4 ) {
            return translations[2];
        } else if( replaceOrInteger > 1 ) {
            return translations[1];
        }

        return translations[0];
    }

    _.forEach(replaceOrInteger, (value, key) => {
        translation = translation.replace(':' + key, value)
    })

    return translation;
}
